/**
 * Gate for {@link recoverContentNotAdvancing}'s `loopWrapScheduleResync`.
 *
 * Len-1 / rotating-embed freezes (#1382) need the loop-wrap bootstrap (idx −1 → 0 + t0 reset).
 * Multi-frame playlists (#1500 Publicar) must NOT: periodic idx-0 rebootstrap resets
 * `lastAdvanceMonotonicMs` and starves the wall-dwell force-advance that would leave the
 * wedged slot.
 */
export function shouldLoopWrapOnContentNotAdvancingRecovery(args: {
  embedAdvanced: boolean
  planLength: number
}): boolean {
  if (args.embedAdvanced) {
    return true
  }
  return args.planLength <= 1
}
